import FetchBase from '../Api/FetchBase'
import { observable, action, onBecomeObserved } from 'mobx'
import { API_ENDPOINTS, DEFAULT_PAGE_START } from '../Utils/constants'
import { generateFormData } from '../Utils/helpers'

export default class NotesStore extends FetchBase {
  @observable notesLoader = false
  @observable totalNotes = 0
  @observable notes = []
  @observable notesAttachment = []
  @observable isUserAssignedInNote = false

  @observable noteCurrentPage = DEFAULT_PAGE_START

  @observable noteSearchText = undefined

  @observable notesDataLoader = false

  @observable noteFilters = {}
  @observable ordering = undefined
  @observable orderingBy = undefined

  @action.bound
  setNotesFilters = (value = {}) => {
    this.noteFilters = value
  }

  @action.bound
  setOrdering = (value = undefined) => {
    this.ordering = value
  }

  @action.bound
  setOrderingBy = (value = undefined) => {
    this.orderingBy = value
  }

  @action.bound
  setNotesSearchText = (value = undefined) => {
    this.noteSearchText = value
  }

  @action.bound
  setNotesCurrentPage = (value = DEFAULT_PAGE_START) => {
    this.noteCurrentPage = value
  }

  @action.bound
  updateNotesLocally = (id, newValue) => {
    this.notes = (this.notes || []).map((note) => {
      if (note.id === id) {
        return {
          ...note,
          ...newValue,
        }
      }
      return note
    })
  }

  @action.bound
  updateNotes = async (id, values) => {
    try {
      this.notesDataLoader = true
      // let response = await this.post(API_ENDPOINTS.UPDATE_NOTE, {
      //   id,
      //   ...values,
      // })
      values['id'] = id

      let response = await this.postWithFormData(
        API_ENDPOINTS.UPDATE_NOTE,
        generateFormData(values)
      )
      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.notesDataLoader = false
    }
  }

  @action.bound
  getNotesByIdLocally = (id) => {
    return (this.notes || []).find((note) => note.id === id)
  }

  @action.bound
  getAllNotesExportData = async (
    projectId,
    { exportFileType = 'csv' } = {}
  ) => {
    try {
      let options = this.getFilteredOptions()
      options['exportFileType'] = exportFileType
      let response = await this.get(API_ENDPOINTS.EXPORT_NOTES, {
        projectId,
        ...options,
      })
      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  getFilteredOptions = () => {
    let temp = {}
    this.noteSearchText && (temp['search'] = this.noteSearchText)
    let keys = Object.keys(this.noteFilters || {})
    for (let filter of keys) {
      if (this.noteFilters[filter] !== undefined) {
        temp[filter] = this.noteFilters[filter]
      }
    }
    if (this.ordering) {
      temp['ordering'] = this.ordering
      temp['orderBy'] = this.orderingBy
    }
    return temp
  }

  @action.bound
  getAllNotes = async (projectId, signal) => {
    try {
      this.notesLoader = true
      let options = this.getFilteredOptions() || {}
      let response = await this.get(
        API_ENDPOINTS.GET_NOTES,
        {
          projectId,
          pageNo: Math.max(this.noteCurrentPage - 1, 0),
          ...options,
        },
        signal
      )
      if (response.status) {
        this.notes = response.data.notes
        this.totalNotes = response.data.total || 0
        this.isUserAssignedInNote = response.isUserAssigned
        return [true, response.data.notes]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.notesLoader = false
    }
  }

  @action.bound
  addNote = async (values) => {
    try {
      this.notesDataLoader = true
      let response = await this.postWithFormData(
        API_ENDPOINTS.ADD_NOTE,
        generateFormData(values)
      )
      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.notesDataLoader = false
    }
  }

  @action.bound
  uploadNoteAttachments = async (values) => {
    try {
      let response = await this.postWithFormData(
        API_ENDPOINTS.ADD_PROJECT_NOTE_ATTACHMENTS,
        generateFormData(values)
      )
      if (response.status) {
        return [true, response.data?.[0]]
      }
    } catch (err) {
      return [false, undefined]
    } finally {
    }
  }

  @action.bound
  deleteActionItemAttachment = async (imageId) => {
    try {
      let response = await this.post(API_ENDPOINTS.DELETE_ATTACHMENTS, {
        id: imageId,
      })
      if (response.status) {
        return [true, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    }
  }

  @action.bound
  deleteNote = async (id, values = {}) => {
    try {
      this.deleteCommentLoader = true
      let response = await this.post(API_ENDPOINTS.DELETE_NOTE, {
        id,
        ...values,
      })
      if (response.status) {
        return [response.status, response.data]
      }
      return [false, undefined]
    } catch (err) {
      return [false, undefined]
    } finally {
      this.deleteCommentLoader = false
    }
  }

  @action.bound
  resetNotesFilters = () => {
    this.noteFilters = {}
  }

  @action.bound
  resetStore = () => {
    this.notesLoader = false
    this.totalNotes = 0
    this.notes = []
    this.notesAttachment = []
    this.isUserAssignedInNote = false
    this.noteCurrentPage = DEFAULT_PAGE_START
    this.noteSearchText = undefined
    this.notesDataLoader = false
    this.noteFilters = {}
    this.ordering = undefined
    this.orderingBy = undefined
  }
}
